import styled from 'styled-components';

import { Button } from '@ontruck/orc';

export default styled(Button)`
  && {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
